import { createApp } from 'vue'
import App from './AuthSection.vue'
import { createPinia } from 'pinia'
const pinia = createPinia()

// @ts-ignore
window.pinia = pinia

// @ts-ignore
window.authSection = createApp(App)
    .use(pinia)
    .mount('#auth-section')
